angular.module('unica_grand_prix.grand_prix_services')

.factory('GrandPrixRankingListService', function ($http, getBaseApiURL) {

	var rankingListService = {};


	rankingListService.list = function (invitationListId, limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/grand-prix/ranking/list/' + invitationListId,
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.rankings;
			}

		});
	};


	rankingListService.fullList = function ( invitationListId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/grand-prix/ranking/full-list/' + invitationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.rankings;
			}

		});
	};


	rankingListService.get = function ( rankingId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/grand-prix/ranking/detail/' + rankingId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.data;
			}

		});
	};


	rankingListService.getByHash = function (hash)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/grand-prix/ranking/detail-by-hash/' + hash,
		}).then(function(result) {

			if ( result ) {
				return result.data.data;
			}

		});
	};


	rankingListService.getAgencyUsersNoInvited = function ( rankingId, usersToExclude )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/grand-prix/ranking/get-agency-users-no-invited/' + rankingId,
			data: {
				users_to_exclude: usersToExclude
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.users;
			}

		});
	};


	rankingListService.listZm = function ( userId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/grand-prix/ranking/list-zm/' + userId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.rankings;
			}

		});
	};


	rankingListService.exportGrandPrix = function (invitationListId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/grand-prix/' + invitationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	rankingListService.exportGrandPrixAgencies = function (invitationListId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/grand-prix/agencies/' + invitationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	rankingListService.exportGrandPrixClick = function (invitationListId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/grand-prix/click/' + invitationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	return rankingListService;

});